import React, { useContext, useEffect, useState } from "react";
import { Box, Text, Heading, Button, Flex, SimpleGrid, Center, Spinner, } from "@reverb-ui/react";
import { Link } from "@reverb-ui/icons-react";
import { useFlag } from "@unleash/proxy-client-react";
import { I18nextProvider, useTranslation } from "react-i18next";
import StudioFullLogo from "@/assets/icons/products/studio.svg";
import IonFullLogo from "@/assets/icons/products/ion.svg";
import StageFullLogo from "@/assets/icons/products/stage.svg";
import { ProductContext } from "@/shared/presentation/context-api/providers/product";
import { RockContentIcon, StageIcon, } from "@/shared/presentation/components/icons";
import { AuthContext } from "@/shared/presentation/context-api/providers/auth";
import RockULogo from "@/assets/icons/products/rock-university.svg";
import IClipsIcon from "@/assets/icons/products/iclips.svg";
import LiveIcon from "@/assets/icons/products/live.svg";
import GTNIcon from "@/assets/icons/products/gtn.svg";
import i18n from "../../../main/i18n/config";
import { products_en } from "../../../main/i18n/en";
import { products_pt_br } from "../../../main/i18n/pt-br";
var ProductBox = function (_a) {
    var message = _a.message, logo = _a.logo, endDate = _a.endDate;
    var t = useTranslation("products").t;
    var getProductByCode = {
        studio: {
            icon: React.createElement(StudioFullLogo, null),
        },
        "studio 3": {
            icon: React.createElement(StudioFullLogo, null),
            text: t("studio-description"),
        },
        "studio 2.0": {
            icon: React.createElement(StudioFullLogo, null),
            text: t("studio-description"),
        },
        "studio 3.0": {
            icon: React.createElement(StudioFullLogo, null),
            text: t("studio-description"),
        },
        ion: {
            icon: React.createElement(IonFullLogo, null),
            text: t("ion-description"),
        },
        live: {
            icon: React.createElement(LiveIcon, null),
            text: t("live-description"),
        },
        stage: {
            icon: React.createElement(StageFullLogo, null),
            text: t("stage-description"),
        },
        iclips: { icon: React.createElement(IClipsIcon, null), text: "" },
        "global talent network": {
            icon: React.createElement(GTNIcon, null),
            text: t("gtn-description"),
        },
        "rock university": {
            icon: React.createElement(RockULogo, null),
            text: t("university-description"),
        },
        "stage legacy": {
            icon: React.createElement(StageIcon, null),
            text: t("stage-description"),
        },
    };
    var getProductUrl = {
        studio: "https://studio.rockcontent.com",
        "studio 2.0": "https://plataforma.rockcontent.com",
        "studio 3": "https://studio.rockcontent.com",
        "studio 3.0": "https://studio.rockcontent.com",
        ion: "https://ion.rockcontent.com",
        live: "https://live.rockcontent.com",
        stage: "https://stage.rockcontent.com",
        iclips: "https://studio.rockcontent.com",
        "global talent network": "https://gtn.rockcontent.com",
        "rock university": "https://university.rockcontent.com",
        "stage legacy": "https://stage.rockcontent.com",
    };
    var productInfo = getProductByCode[logo.toLowerCase()];
    return (React.createElement(Flex, { direction: "column", boxShadow: "md", bg: "white", borderRadius: "8", p: "6" },
        React.createElement(Box, { h: "60px" }, (productInfo === null || productInfo === void 0 ? void 0 : productInfo.icon) || React.createElement(RockContentIcon, null)),
        (productInfo === null || productInfo === void 0 ? void 0 : productInfo.text) ? (React.createElement(Text, { color: "gray.600" }, productInfo.text)) : (React.createElement(Text, { fontWeight: "600", color: "black", fontSize: "xl", mt: "4" }, message)),
        React.createElement(Flex, { justifyContent: "end", pt: "6", marginTop: "auto" },
            React.createElement(Button, { variant: "outline", rightIcon: React.createElement(Link, null), onClick: function () {
                    return window.open(getProductUrl[logo.toLowerCase()], "_blank");
                } }, t("open")))));
};
export var ProductsContainer = function () {
    var t = useTranslation("products").t;
    var otherProductsEnabled = useFlag("account.other-products");
    var talentWalletId = useContext(AuthContext).talentWalletId;
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    useEffect(function () {
        i18n.addResourceBundle("en", "products", products_en);
        i18n.addResourceBundle("pt", "products", products_pt_br);
        setLoading(false);
    }, []);
    return (React.createElement(I18nextProvider, { i18n: i18n }, loading ? (React.createElement(Center, { h: "100%", w: "100%" },
        React.createElement(Spinner, null))) : (React.createElement(ProductContext.Consumer, null, function (_a) {
        var currentSkus = _a.currentSkus, entityProductsPlatforms = _a.entityProductsPlatforms;
        return (React.createElement(Box, { w: "100%", p: "8", px: "16" },
            React.createElement(Heading, { fontWeight: "800", textAlign: "start", color: "black", fontSize: "2xl" }, t("products")),
            React.createElement(Box, { py: "6" },
                React.createElement(Heading, { py: "2", color: "gray.800", fontWeight: "600", fontSize: "md" }, t("hired-products")),
                React.createElement(SimpleGrid, { pt: "4", gridGap: "4", columns: 3 },
                    entityProductsPlatforms.map(function (productPlatform, index) { return (React.createElement(ProductBox, { key: index, message: productPlatform.name, logo: productPlatform.name })); }),
                    talentWalletId && (React.createElement(ProductBox, { message: "Global Talent Network", logo: "Global Talent Network" })),
                    React.createElement(ProductBox, { message: "Rock University", logo: "rock university" }))),
            otherProductsEnabled && (React.createElement(Box, { py: "6" },
                React.createElement(Heading, { py: "2", color: "gray.800", fontWeight: "600", fontSize: "md" }, t("other-rock-products")),
                React.createElement(SimpleGrid, { pt: "4", gridGap: "4", columns: 3 },
                    currentSkus.possiblesCrossSell.length === 0 && (React.createElement(Text, { color: "grey" }, t("no-offers"))),
                    currentSkus.possiblesCrossSell.map(function (crossSell, index) { return (React.createElement(ProductBox, { key: index, message: t("you-dont-have") + " " + crossSell.description + " " + t("yet") + "!", logo: crossSell.description })); }))))));
    }))));
};
